module.exports = __webpack_public_path__ + "49b557cd4c0520f61e1230d8e925225d.MP3";